import { FormControl, Grid, InputLabel, TextField, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';
import { useTranslation } from '../../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';

interface Props {
  novoUsuario: boolean;
}

const PPCStepper5: React.FC<Props> = (props: Props) => {
  const { translate, language } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const { novoUsuario } = props;
  const methods = useFormContext();

  const handleAutoSave = () => {
    document.getElementById('btnSavePPC')?.click();
  };

  return (
    <>
      <Grid container xs={12} md={12} sm={12} sx={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
      }}>
        <Grid xs={12} md={12} sm={12}>
          <Typography sx={{ padding: "10px 0px" }} variant="h4" component="h2">
            {translate("reflexaoDeCarreriaTitulo")}
          </Typography>
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal"
          }}>
            {translate("reflexaoDeCarreriaP1")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP1'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                multiline
                maxRows={4}
                onBlur={handleAutoSave}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal"
          }}>
            {translate("reflexaoDeCarreriaP2")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP2'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}

                variant="standard"
                multiline
                maxRows={4}
                onBlur={handleAutoSave}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal"
          }}>
            {translate("reflexaoDeCarreriaP3")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP3'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                multiline
                maxRows={4}
                onBlur={handleAutoSave}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal"
          }}>
            {translate("reflexaoDeCarreriaP4")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP4'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                multiline
                maxRows={4}
                onBlur={handleAutoSave}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal"
          }}>
            {translate("reflexaoDeCarreriaP5")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP5'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                multiline
                maxRows={4}
                onBlur={handleAutoSave}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal"
          }}>
            {translate("reflexaoDeCarreriaP6")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP6'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                multiline
                maxRows={4}
                onBlur={handleAutoSave}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal"
          }}>
            {translate("reflexaoDeCarreriaP7")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP7'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                multiline
                maxRows={4}
                onBlur={handleAutoSave}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal"
          }}>
            {translate("reflexaoDeCarreriaP8")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP8'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                multiline
                maxRows={4}
                onBlur={handleAutoSave}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal"
          }}>
            {translate("reflexaoDeCarreriaP9")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP9'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                multiline
                maxRows={4}
                onBlur={handleAutoSave}
              />
            )}
          />
        </Grid>
      </Grid>

    </>
  );
};

export default PPCStepper5;
